import { rootApi } from "../../api/rootApi";

export const feedbackApi = rootApi.injectEndpoints({
  endpoints: (builder) => ({
    fetchFeedback: builder.mutation({
      query: (params) => {
        return {
          method: "POST",
          url: `/app/feedback`,
          headers: {
            "Content-Type": "application/json",
            Authorization: "Bearer " + params.token,
            slug: params.tenant_id,
          },
          body: params.body,
        };
      },
    }),


    countFeedback: builder.mutation({
      query: (params) => {
        return {
          method: "POST",
          url: `/app/feedback/count`,
          headers: {
            "Content-Type": "application/json",
            Authorization: "Bearer " + params.token,
            slug: params.tenant_id,
          },
          body: params.body,
        };
      },
    }),

  }),
});

export const {
  useFetchFeedbackMutation,
  useCountFeedbackMutation
} = feedbackApi;
